import React from 'react'
import OurServices from './services copy 6'
import { useContext } from 'react'
import NoteContext from '../context/notes/noteContext'
import Projects from './services copy 7'
import { Link } from 'react-router-dom'
import AboutCompany from './aboutcompany'
export default function WhoWeAre(params) {
    const context = useContext(NoteContext)
    const { setBars,setBackgroundColor } = context
    setBars('grey-bars')
    setBackgroundColor('black')
    return (
        <div>
            <div className="">
                <div className="">
                    <div style={{ backgroundColor: '#f8f9f9' }}>
                        <div className="container px-4 py-5">
                            <div className="d-flex justify-content-between">
                                <h1 className='serviceheading really-bold'>WHO WE ARE</h1>
                                <button style={{ borderRadius: '0px', backgroundColor: "#A10302", color: 'white', height: 'max-content' }} className="btn">GET IN TOUCH</button>
                            </div>
                        </div>
                    </div>
                  
                    <div className="container">
                       
                        <div className='mb-5'>
                          <AboutCompany/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/servicesMain copy 2.jsx